<template>
    <div class="form-group">
        <label v-if="label" :for="labelFor || null">{{ label }}</label>
        <slot />
        <small v-if="description" class="form-text text-muted">{{ description }}</small>
    </div>
</template>
<script>
export default {
    name: "SbFormGroup",
    props: {
        label: { type: String, default: null },
        labelFor: { type: String, default: null },
        description: { type: String, default: null },
    },
};
</script>
